'use client';
import { useAxios } from '@/hooks';
import { setCartData } from '@/redux/actions/user.action';
import { AppDispatch } from '@/redux/store';
import { EventDataType } from '@/types/EventDataType.type';
import { endPoint } from '@/utils';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export function useEventInfo(slug: string | string[] | undefined) {
  const [step, setStep] = useState(0);
  const onNext = (specificStep?: number) => specificStep ? setStep(specificStep) : setStep(step => step + 1);

  const [eventInfo, setEventInfo] = useState<EventDataType | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  const { fetchData, loading } = useAxios();

  const fetchEventInfo = async () => {
    try {
      const result: any = await fetchData({
        url: endPoint.FETCH_EVENT_INFO,
        method: 'GET',
        params: {
          eventCode: slug,
        },
      });

      const res: EventDataType = result?.data;

      if (!res?.isRecurringEvent) {
        dispatch(setCartData({ date: res.eventDate ?? res.dateString }, {}, {}));
        setStep(1);
      }

      setEventInfo(result?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchEventInfo();
  }, []);

  return {
    loading,
    eventInfo,
    step,
    onNext,
  };
}
